export class ObjectInfo {
    public __classname__: string = 'ObjectInfo';

    public ID : string | null = null;
	public Name : string | null = null;
	public Type: string | null = null;
	public Format: string | null = null;

    constructor(
        ID : string | null = null, 
        Name : string | null = null, 
        Type: string | null = null, 
        Format: string | null = null
    ) {
        this.ID = ID;
        this.Name = Name;
        this.Type = Type;
        this.Format = Format;
    }
}